import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Upload } from '../models/upload';
import { UploadStatus } from '../models/uploadStatus';

@Injectable({
              providedIn: 'root'
            })
export class UploadService {
  private uploadTask: firebase.storage.UploadTask;
  private uploadStatus = new BehaviorSubject(new UploadStatus('none', 0, 'not started'));

  constructor() {
  }

  uploadImage(upload: Upload): Observable<UploadStatus> {
    const storageRef = firebase.storage().ref();
    this.uploadTask = storageRef.child(`/bericht_afbeeldingen/${upload.key}`).put(upload.file);

    this.uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
                       (snapshot) => {
                         const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                         this.uploadStatus.next(new UploadStatus(upload.key, percentage, 'upload in progress'));
                       },
                       (error) => {
                         this.uploadStatus.error(error);
                       },
                       () => {
                         this.uploadStatus.next(new UploadStatus(upload.key, 100, 'upload success'));
                       });
    return this.uploadStatus.asObservable();
  }

  reset() {
    this.uploadTask = undefined;
    this.uploadStatus = new BehaviorSubject(new UploadStatus('none', 0, 'not started'));
  }
}
